<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>订单信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">核销状态</div>
              <div class="itemNum jishi">{{ form.orderStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">核销渠道</div>
              <div class="itemNum">{{ form.orderSourceCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">登记时间</div>
              <div class="itemNum">{{ formatDate(form.oxCtime) }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.orderSource != 'yuanjian'">
              <div class="itemName">核销劵码</div>
              <div class="itemNum">{{ form.consumeCode }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.orderSource != 'yuanjian'">
              <div class="itemName">二维码</div>
              <div class=""><vue-qr :text="form.consumeCode" :margin="0" colorDark="#000" colorLight="#fff"
                  :logoScale="0.3" :size="100"></vue-qr></div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName"></div>
              <div class="itemNum jishi cur" @click="lookOrders">查看订单>></div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>登记明细</i></p>
          <div class="totals-box mlr24">
            <el-row class="order-details">
              <el-col :span="10" class="pl10">商品名称</el-col>
              <el-col :span="4" class="center">单价(元)</el-col>
              <el-col :span="2" class="center">数量</el-col>
              <el-col :span="4" class="center">优惠(元)</el-col>
              <el-col :span="4" class="tRight pr10">实付(元)</el-col>
            </el-row>
            <el-row v-for="(item, index) in form.orderItemList" :key="index" class="mt20">
              <el-col :span="10" class="pl10">{{ item.itemName }}</el-col>
              <el-col :span="4" class="color999 center">{{ item.salePrice }}</el-col>
              <el-col :span="2" class="color999 center">{{ item.itemNum }}</el-col>
              <el-col :span="4" class="center">{{ item.discountAmount }}</el-col>
              <el-col :span="4" class="tRight pr10">{{ item.realPayAmount }}</el-col>
              <el-col :span="4" class="pl10 mt20 color999">技师</el-col>
              <el-col :span="20" class="mt20 tRight pr10">
                <div class="jishi">{{ item.staffNames }}</div>
              </el-col>
            </el-row>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>登记金额</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">登记数量</div>
              <div class="itemNum jishi">{{ form.itemNum }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">登记金额</div>
              <div class="itemNum moneys">￥{{ form.orderAmount }}</div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <!-- 继续支付标识-->
          <div class="pr24 pb10"><el-button type="primary" @click="save"
              v-if="form.orderStatus == 'processing'">确认已核销</el-button></div>
        </div>
      </div>
    </drawer>
    <edit-set ref="editForm" @change="refreshPage"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import vueQr from 'vue-qr';
import editSet from "../../orderInfo/edit.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    vueQr,
    editSet
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "登记详情",
      dialogHide: false,
      form: {
        orderType: "",
        id: ''
      },
      dialogHide: false,
      setDeductAmount: 0,
    };
  },
  created() {
    this.init();
  },
  mounted() {

  },
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function (org) {
        this.$api.get(this.$url.order.get, {
          id: org
        }).then(res => {
          if (res) {
            this.addEditShow = true;
            this.form = res;
            this.form.id = org
            this.form.orderTime = this.formatDate(this.form.orderTime);
            this.form.payTime = this.formatDate(this.form.payTime);
            this.form.oxCtime = this.formatDate(this.form.oxCtime);
          }
        }).catch(error => { });
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", true);
    },
    setStaff(item, index) {
      this.$refs["deductSetForm"].$emit("set", {
        single: true,
        staffIds: item.staffId,
        index: index
      });
    },
    handleChange(bool) {
      this.addEditShow = false;
      this.$emit("change", true);
    },
    back() {
      this.addEditShow = false;
      this.$emit("change", false);
    },

    // 保存
    save() {
      let that = this
      this.$confirm("请确认已在第三方券商家端完成核销验券", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$api.get(this.$url.order.finishBySelf, { id: that.form.id }).then(res => {
            if (res) {
              this.addEditShow = false;
              this.$emit("change", true);
              this.$api.success();
            }
          });
        })
        .catch(() => { });

    },
    lookOrders(item) {
      this.$refs["editForm"].$emit("set", this.form.orderId);
    },
    refreshPage(org) {
      if (org) this.$api.get(this.$url.order.get, {
        id: this.form.id
      }).then(res => {
        if (res) {
          this.form = res;
        }
      }).catch(error => { });
    }
  }
};
</script>
<style>
.payway-success .el-button+.el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
</style>